
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'VantaReportingSection',

  props: {
    reportIssues: {
      type: Boolean,
      required: true
    },
    reportVulnerabilities: {
      type: Boolean,
      required: true
    },
    disableSettingsToggle: {
      type: Boolean,
      default: false
    }
  },

  emits: ['toggleVantaSetting'],

  methods: {
    toggleVantaSetting(key: string) {
      this.$emit('toggleVantaSetting', key)
    }
  }
})
